import { Controller, useFormContext } from 'react-hook-form';

import { Field, TimeOfDayPicker } from '@grafana/ui';
import { t } from 'app/core/internationalization';
import { ReportBaseV2 } from 'app/extensions/types/reports';

export function EndTimeInput() {
  const { control } = useFormContext<ReportBaseV2>();

  return (
    <Field label={t('share-report.schedule.end-time', 'End time')}>
      <Controller
        name="schedule.endTime"
        render={({ field: { ref, ...field } }) => {
          return <TimeOfDayPicker {...field} minuteStep={10} />;
        }}
        control={control}
      />
    </Field>
  );
}
